import { Route } from 'src/constants/routes';

const titles = {
  [Route.DASHBOARD]: 'Tableau de bord',
  [Route.DONOR_DASHBOARD]: 'Mon tableau de bord',
  [Route.CONTACTS]: 'Contacts',
  [Route.INVOICES]: 'Factures',
  [Route.PAYMENTS]: 'Paiements',
  [Route.SUBSCRIPTIONS]: 'Abonnements',
  [Route.FUNDRAISING]: 'Levée de fonds',
  [Route.FUNDRAISING_TRANSACTION]: 'Transaction des levée de fonds',
  [Route.FUNDRAISING_STATISTICS]: 'Statistiques de la campagne',
  [Route.SETTINGS]: 'Configurations',
  [Route.INVOICES_PAYMENT]: 'Factures pour Paiement',
  [Route.INVOICES_CONTACT]: 'Factures pour Contact',
  [Route.PAYMENTS_INVOICE]: 'Paiements pour Factures',
  [Route.INVOICES_SUBSCRIPTION]: 'Factures pour Abonnement',
  [Route.PAYMENTS_SUBSCRIPTION]: 'Paiements pour Abonnement',
  [Route.PAYMENTS_CONTACT]: 'Paiements pour Contact',
  [Route.ORGANISATIONS]: 'Organisations',
};

export default titles;
